module.exports = __webpack_public_path__ + "img/user-3-banner.09867d37.jpeg";